import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

const Basis = Loadable(lazy(() => import('views/basis/Single')));
const BasisJoin = Loadable(lazy(() => import('views/basis/Join')));
const UserSingle = Loadable(lazy(() => import('views/user/Single')));
const UserGroupSingle = Loadable(lazy(() => import('views/userGroup/Single')));
const Upgrade = Loadable(lazy(() => import('views/upgrade')));
const Doc = Loadable(lazy(() => import('views/doc')));
const DocSingle = Loadable(lazy(() => import('views/doc/Single')));
const DocPeriod = Loadable(lazy(() => import('views/docPeriod')));
const DocPeriodSingle = Loadable(lazy(() => import('views/docPeriod/Single')));
const Borrow = Loadable(lazy(() => import('views/borrow')));
const BorrowSingle = Loadable(lazy(() => import('views/borrow/Single')));
const Author = Loadable(lazy(() => import('views/author')));
const AuthorSingle = Loadable(lazy(() => import('views/author/Single')));
const Subject = Loadable(lazy(() => import('views/subject')));
const SubjectSingle = Loadable(lazy(() => import('views/subject/Single')));
const Publisher = Loadable(lazy(() => import('views/publisher')));
const PublisherSingle = Loadable(lazy(() => import('views/publisher/Single')));
const Report = Loadable(lazy(() => import('views/report')));
const ReportDesigner = Loadable(lazy(() => import('views/report/Designer')));
const ReportPrint = Loadable(lazy(() => import('views/report/Print')));
const Ranking = Loadable(lazy(() => import('views/ranking')));
const Profile = Loadable(lazy(() => import('views/profile')));
const Payment = Loadable(lazy(() => import('views/payment')));
const Chat = Loadable(lazy(() => import('views/chat')));
const ChatSingle = Loadable(lazy(() => import('views/chat/Single')));
const Tel = Loadable(lazy(() => import('views/contact/tel')));
const Social = Loadable(lazy(() => import('views/contact/social')));
const About = Loadable(lazy(() => import('views/features/about')));
const Terms = Loadable(lazy(() => import('views/features/terms')));
const Share = Loadable(lazy(() => import('views/features/share')));
const Rate = Loadable(lazy(() => import('views/features/rate')));
const Faq = Loadable(lazy(() => import('views/features/faq')));
const Wallet = Loadable(lazy(() => import('views/wallet')));
const Account = Loadable(lazy(() => import('views/account')));
const Splash = Loadable(lazy(() => import('views/pages/Splash')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <Splash width="256px" height="256px" />
        },
        {
            path: '*',
            element: <DashboardDefault />
        },
        {
            path: '/dashboard',
            element: <DashboardDefault />
        },
        {
            path: '/basis/:basisId',
            element: <Basis />
        },
        {
            path: '/basis/:basisId/user/:userId',
            element: <UserSingle />
        },
        {
            path: '/basis/:basisId/user_group/:userGroupId',
            element: <UserGroupSingle />
        },
        {
            path: '/basis/join',
            element: <BasisJoin />
        },
        {
            path: '/basis/join/:basisLink',
            element: <BasisJoin />
        },
        {
            path: '/basis/:basisId/upgrade',
            element: <Upgrade />
        },
        {
            path: '/basis/:basisId/docs',
            element: <Doc />
        },
        {
            path: '/basis/:basisId/doc/:docId',
            element: <DocSingle />
        },
        {
            path: '/basis/:basisId/doc_periods',
            element: <DocPeriod />
        },
        {
            path: '/basis/:basisId/doc_period/:docPeriodId',
            element: <DocPeriodSingle />
        },
        {
            path: '/basis/:basisId/authors',
            element: <Author />
        },
        {
            path: '/basis/:basisId/author/:authorId',
            element: <AuthorSingle />
        },
        {
            path: '/basis/:basisId/subjects',
            element: <Subject />
        },
        {
            path: '/basis/:basisId/subject/:subjectId',
            element: <SubjectSingle />
        },
        {
            path: '/basis/:basisId/publishers',
            element: <Publisher />
        },
        {
            path: '/basis/:basisId/publisher/:publisherId',
            element: <PublisherSingle />
        },
        {
            path: '/basis/:basisId/reports',
            element: <Report />
        },
        {
            path: '/basis/:basisId/report_designer',
            element: <ReportDesigner />
        },
        {
            path: '/basis/:basisId/report_designer/:repName',
            element: <ReportDesigner />
        },
        {
            path: '/basis/:basisId/report_print',
            element: <ReportPrint />
        },
        {
            path: '/basis/:basisId/report_print/:repName',
            element: <ReportPrint />
        },
        {
            path: '/borrows',
            element: <Borrow />
        },
        {
            path: '/borrow/:borrowId',
            element: <BorrowSingle />
        },
        {
            path: '/chats',
            element: <Chat />
        },
        {
            path: '/chat/:chatId',
            element: <ChatSingle />
        },
        {
            path: '/ranking',
            element: <Ranking />
        },
        {
            path: '/profile',
            element: <Profile />
        },
        {
            path: '/profile/:userId',
            element: <Profile />
        },
        {
            path: '/payment/:paymentId',
            element: <Payment />
        },
        {
            path: '/social',
            element: <Social />
        },
        {
            path: '/tel',
            element: <Tel />
        },
        {
            path: '/about',
            element: <About />
        },
        {
            path: '/terms',
            element: <Terms />
        },
        {
            path: '/share',
            element: <Share />
        },
        {
            path: '/rate',
            element: <Rate />
        },
        {
            path: '/faq',
            element: <Faq />
        },
        {
            path: '/wallet',
            element: <Wallet />
        },
        {
            path: '/account',
            element: <Account />
        }
    ]
};

export default MainRoutes;
